import {BlockedOperative, blockedOperativeIsAll} from 'src/app/domain/model/customer/operational-block-reason/BlockedOperative.model';
import {BlockedReasonDescription} from 'src/app/domain/model/customer/operational-block-reason/BlockedReasonDescription.model';

export interface BlockReason {
  blockedAt: string; // "2016-05-28T14:44:31"
  blockedUntil: string|null; // "2016-05-28T14:44:31"
  blockedReasonDescription: BlockedReasonDescription;
  blockedOperatives: BlockedOperative[];
}

export const hasTotalBlockedOperatives = (blockReason: BlockReason): boolean =>
  blockReason.blockedOperatives.some(blockedOperative => blockedOperativeIsAll(blockedOperative));
